<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">统计</a></el-breadcrumb-item>
          <el-breadcrumb-item>微信收款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item >
            <el-input  placeholder="消息名称" v-model="queryParam.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="BillNumber" :show-overflow-tooltip="true" fixed="left" label="单据号"> </el-table-column>
          <el-table-column  prop="Name"  :show-overflow-tooltip="true"  label="所属商家"> </el-table-column>
          <el-table-column  prop="Amount"  label="金额"> </el-table-column>
          <el-table-column  prop="MchType"  label="收款账户"> </el-table-column>
          <el-table-column  prop="MchId"  label="商户号"  > </el-table-column>
          <el-table-column  prop="SubMchId"  label="子商户号"   ></el-table-column>
          <el-table-column  prop="CreateTime"  width="120px" label="操作时间" :formatter="dateFormat"> </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam: {
          pageIndex: 1,
          pageSize: 10,
          sort: ' CreateTime desc ',
          totalCount:10,
          name:'',
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/WeiXinPayNote',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.queryParam.items = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
  

</style>